import React, { useEffect, useState, useRef } from "react";
import { IoPricetagOutline } from "react-icons/io5";
import { CiSquarePlus } from "react-icons/ci";
import { HiOutlineRefresh } from "react-icons/hi";
import { IoIosArrowRoundBack } from "react-icons/io";
import Tooltip from "@mui/material/Tooltip";
import Call from "../images/Call.png";
import IconButton from "@mui/material/IconButton";
import VerifiedIcon from '@mui/icons-material/Verified';
import Email from "../images/email.png";
import Tag from "../images/tag.png";
import Chat from "../images/chat.png";
import Note from "../images/note.png";
import "./contactverifier.css";
import PropTypes from "prop-types";
import {
  EmailRounded,
  PhoneRounded,
  ContentCopyOutlined,
  KeyboardBackspaceRounded,
  LinkedIn,
} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import { Box, Checkbox, Chip, Dialog, DialogContent, DialogActions, FormControlLabel, InputBase, Menu, MenuItem, Pagination, Select, TextField } from "@mui/material";
import Paper from "@mui/material/Paper";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import { Grid, Button, Toolbar, Divider, ListItemButton } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import SearchIcon from "@mui/icons-material/Search";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import axios from "axios";
import { TbBrandLinkedin } from "react-icons/tb";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import InfiniteScroll from "react-infinite-scroll-component";
import Key from "../../clientVariables.json";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import moment from "moment";
import Search from "../Companies/Searchcontact";
import ContactActivity from "./ContactActivity";
import UpdateCompanyContact from "./UpdateCompanyContact";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import { companiesManagementSelector } from "./redux/selector";
import AddCompanyContact from "./AddCompanyContact";
import CompanyJobs from "./CompanyJobs";
import CompanyJobDetail from "./CompanyJobDetail";
import Contacts from "./Contacts";
import {
  CheckCircleOutlineOutlined,
  StarBorder,
  Star,
} from "@mui/icons-material";
import { Card, Stack, Skeleton } from "@mui/material";
import { userSelector } from "../user-redux/selector";
import { RxCross2 } from "react-icons/rx";
import LoadingSkeleton from "../loadingSkeletons/LoadingList";
import FilterListIcon from "@mui/icons-material/FilterList";
import WorkIcon from "@mui/icons-material/Work";
import CloseIcon from "@mui/icons-material/Close";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import { toast } from "react-toastify";
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

// const limit = 20;

function Companyinfo(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Mobile devices
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Tablets
  const { user } = useSelector(userSelector);
  const scrollRef = useRef(null);
  const [copied, setCopied] = useState(false);
  const { searchInput, searchType } = useSelector(companiesManagementSelector);
  const [hideContacts, setHideContacts] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [companyId, setCompanyId] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyDetails, setCompanyDetails] = useState([]);
  const [showContacts, setShowContacts] = useState(true);
  const [companyContacts, setCompanyContacts] = useState([]);
  const [companyJobs, setCompanyJobs] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [offset, setOffset] = useState(0);
  const [favoffset, setFavOffset] = useState(0);
  const [favhasMore, setFavHasMore] = useState(true);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [showAddContactPopup, setShowAddContactPopup] = useState(false);
  const [contactDetails, setContactDetails] = useState({});
  const [jobDetails, setJobDetails] = useState({});
  const [selectedcontact, setselectedcontact] = useState(null);
  const [jobshasmore, setjobshasmore] = useState(true);
  const [contactshasmore, setcontactshasmore] = useState(true);
  const [dateFilter, setDateFilter] = useState("all");
  const [filteredCompanyJobs, setFilteredCompanyJobs] = useState([]);
  const [loading, setLoading] = useState(true); // Initialize loading state
  const [companiesPerPage, setCompaniesPerPage] = useState(10)
  const [joboffset, setjoboffset] = useState(0);
  const [contactsoffset, setcontactsoffset] = useState(0);
  const [recruiterview, setrecruiterview] = useState(false);
  const [verified, setVerified] = useState(false);
  const [selectedJobId, setselectedJobId] = useState("");
  const [sendMail, setSendMail] = useState(false);
  const [showContactMail, setShowContactMail] = useState(false);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [contactActivityView, setContactActivityView] = useState("");
  const [showEditContact, setShowEditContact] = useState(false);
  const [searchContactsResult, setSearchContactResult] = useState();
  const [searchInputValue, setSearchInputValue] = useState("");
  const [companyLoader, setCompanyLoader] = useState(false);
  const [jobDetailsLoader, setJobDetailsLoader] = useState(false);
  const [searchCompanyInputValue, setSearchCompanyInputValue] = useState("");
  const [contactMailData, setContactMailData] = useState([]);
  const [showMailForm, setShowMailForm] = useState(false);
  const [showContactMessage, setShowContactMessage] = useState(false);
  const [contactMailMessage, setContactMailMessage] = useState("");
  const [contactMailSubject, setContactMailSubject] = useState("");
  const [filter, setFilter] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [favoriteCompanies, setFavoriteCompanies] = useState([]);
  const [favoriteCompaniesSearched, setFavoriteCompaniesSearched] = useState(
    []
  );
  const [menu, setMenu] = useState("Companies");

  const [showSearchInput, setShowSearchInput] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [isFilterApplied, setAppliedFilters] = useState(false);
  // Add ref to track if contacts have been loaded for current company
  const contactsLoadedRef = useRef(false);
  const jobsFetchInFlightRef = useRef(false);
  const jobsFetchRequestIdRef = useRef(0);
  const joboffsetRef = useRef(0);
  const jobshasmoreRef = useRef(true);

  const didFetch = useRef(false);
  const [page, setPage] = React.useState(1);
  const [favPage, setFavPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const autoSelectedFor = React.useRef(null);
  const companiesPageFetchIdRef = React.useRef(0);
  const skipNextCompaniesPageFetchRef = React.useRef(false);
  const [jobsLoading, setJobsLoading] = useState(false);
  const [jobsLoadComplete, setJobsLoadComplete] = useState(false);
  const [contactsLoading, setContactsLoading] = useState(false);
  const [contactsLoadComplete, setContactsLoadComplete] = useState(false);
  const [selectedJobLoader, setSelectedJobLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [totalFavPages, setTotalFavPages] = useState(1);
  const [companiesTotalCount, setCompaniesTotalCount] = useState(0);
  const [favTotalCount, setFavTotalCount] = useState(0);
  // Dialog state
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [selectedJobTypes, setSelectedJobTypes] = useState([]);
  const [companySearch, setCompanySearch] = useState("");
  const [jobTitles, setJobTitles] = useState([]);   // multiple job titles
  const [jobTitleInput, setJobTitleInput] = useState(""); // current input
  const [jobTitleError, setJobTitleError] = useState("");
  const handleSearchClick = () => {
    setShowSearchInput(true);
  };

  const handleSearchInputChange = (e) => {
    let inputvalue = e.target.value.toLowerCase();
    setSearchValue(inputvalue);
    if (menu === "Companies") {
      // Only reset search value, do not fetch companies again automatically
      // fetchCompaniesData(); // <-- Remove this line
    } else {
      setFavPage(1);
      getFavCompanies(undefined, 1, rowsPerPage, inputvalue);
    }
  };

  const closeSearchCompanies = () => {
    setShowSearchInput(false);
    setSearchValue("");

    resetSearchValue();
  };

  const resetSearchValue = () => {
    if (menu === "Companies") {
      // Only reset search value, do not fetch companies again automatically
      // fetchCompaniesData(); // <-- Remove this line
    } else {
      getFavCompanies(undefined, favPage, rowsPerPage, "");
    }
  };

  const textStyle1 = {
    fontSize: "12px",
    marginLeft: "3px",
    cursor: "pointer",
    color: verified ? "green" : "inherit", // Change color to green if verified
  };
  const textStyle = {
    fontSize: "12px",
    marginLeft: "3px",
    cursor: "pointer",
    color: verified ? "green" : "inherit", // Change color to green if verified
  };
  const handleMenuChange = (value) => {
    setMenu(value);
    autoSelectedFor.current = null; // reset so selection re-runs with fresh data
    if (value === "Favourites") {
      setFavPage(1);
      getFavCompanies(undefined, 1, rowsPerPage);
    }
  };

  // Only fetch all companies if there is no search term
  useEffect(() => {
    // console.log('Menu effect ran:', menu, searchValue, searchInput);
    if (menu === "Companies" && !searchValue && !searchInput && !didFetch.current) {
      fetchCompaniesData();
      didFetch.current = true;
    } else if (menu === "Favourites") {
      didFetch.current = false;
    }
    getFavCompanies();
  }, [menu]);

  useEffect(() => {
    if (jobDetails?.companyid === companyDetails?.id && !contactsLoadedRef.current) {
      contactsLoadedRef.current = true;
      getCOmpanyContacts(jobDetails?.companyid, 0, false);
    }
  }, [jobDetails]);

  useEffect(() => {
    setrecruiterview(searchType === "contact");
  }, [searchType]);

  const handleclicknotes = (item) => {
    if (item === "email") {
      setShowContactMail(true);
      setContactActivityView(item);
    } else {
      setShowContactMail(false);
      setSendMail(false);
      setContactActivityView(item);
    }
  };

  // Reusable function to fetch companies list (updated for new response structure)
  const fetchCompaniesList = async ({ page = 1, limit, appliedFilters }) => {
    // get-companies does not use job_titles / job_types — those are for get-jobs only
    const { job_titles, job_types, ...companyFilters } = appliedFilters || {};
    const response = await fetch(`${Key.domain_crm}/company/get-companies`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        page,
        limit,
        user_id: user?.id,
        ...companyFilters
      }),
    });
    const result = await response.json();
    // Defensive: ensure result.data && result.data.data are present
    return {
      ...result,
      companies: result?.data?.data || [],
      count: result?.data?.count || 0,
      total_pages: result?.data?.total_pages || 0,
    };
  };

  const resetToScrollStart = () => {
    // Reset items to the initial state
    setSearchInputValue("");
    setCompanyContacts([]);
    setCompanyJobs([]);
    setcontactsoffset(0);
    setjoboffset(0);
    joboffsetRef.current = 0;
    setjobshasmore(true);
    jobshasmoreRef.current = true;
    jobsFetchInFlightRef.current = false;
    setJobsLoadComplete(false);
    setContactsLoadComplete(false);
    setContactDetails({});
    setJobDetails({});
    // Reset contacts loaded ref
    contactsLoadedRef.current = false;

    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }

    const jobsScrollEl = document.getElementById("companyJobsScrollableDiv");
    if (jobsScrollEl) {
      jobsScrollEl.scrollTop = 0;
    }
  };


  const getCompanyDetails = (
    company_ID,
    { forceRefresh = false, jobFilterOverrides = {} } = {}
  ) => {
    const parsedId = parseInt(company_ID);
    const currentId = parseInt(companyDetails?.id);
    const isDifferentCompany = currentId !== parsedId;

    if (!isDifferentCompany && !forceRefresh) {
      return;
    }

    const refreshJobs = (id) => {
      resetToScrollStart();
      getCompanyJobs(id, 0, undefined, jobFilterOverrides);
    };

    if (isDifferentCompany) {
      contactsLoadedRef.current = false;

      fetch(`${Key.domain_crm}/company/get_Company_Details`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ company_id: company_ID }),
      }).then((response) => {
        response.json().then((resdata) => {
          const company = resdata?.data?.[0];
          if (!company) return;

          setCompanyId(company.id);
          setCompanyName(company.name);
          setCompanyDetails(company);
          refreshJobs(company.id);
        });
      });
    } else {
      refreshJobs(company_ID);
    }
  };

  // helper to centralize selection
  const selectCompany = React.useCallback((c, options = {}) => {
    if (!c) return;
    const { forceRefresh = false, jobFilterOverrides } = options;
    setSelectedCompanyId((prevId) => {
      if (prevId !== c.id) {
        setCompanyContacts([]);
      }
      return c.id;
    });
    setCompanyId(c.id);
    setCompanyName(c.name);
    getCompanyDetails(c.id, {
      forceRefresh,
      ...(jobFilterOverrides !== undefined ? { jobFilterOverrides } : {}),
    });
    setrecruiterview(false);
  }, [getCompanyDetails]);

  const beginCompaniesPageTransition = React.useCallback(() => {
    // Keep previous list highlight/selection out of jobs panel while new page loads.
    // Do NOT reset autoSelectedFor here — that causes a stale select of the old page's first company.
    setSelectedCompanyId(null);
    setselectedJobId("");
    setCompanyJobs([]);
    setJobsLoadComplete(false);
    setJobsLoading(true);
    setSelectedJobLoader(true);
    setContactsLoading(true);
    setContactsLoadComplete(false);
    setCompanyContacts([]);
    setContactDetails({});
    setJobDetails({});
    jobsFetchRequestIdRef.current += 1;
    jobsFetchInFlightRef.current = false;
  }, []);

  const beginFilterTransition = React.useCallback(() => {
    // All panels load together on apply/clear filter (companies + jobs + details + recruiter)
    setLoading(true);
    autoSelectedFor.current = "Companies";
    beginCompaniesPageTransition();
  }, [beginCompaniesPageTransition]);

  useEffect(() => {
    autoSelectedFor.current = null;
  }, [menu]);

  useEffect(() => {
    if (menu === "Companies") {
      if (companies?.length && autoSelectedFor.current !== "Companies") {
        autoSelectedFor.current = "Companies";
        selectCompany(companies[0]);
      }
    } else if (menu === "Favourites") {
      if (favoriteCompaniesSearched?.length && autoSelectedFor.current !== "Favourites") {
        autoSelectedFor.current = "Favourites";
        // Check if there is a newly-favorited company we should jump to
        const targetId = sessionStorage.getItem("target_favorite_company_id");
        if (targetId) {
          const found = favoriteCompaniesSearched.find(
            (c) => String(c.id) === String(targetId)
          );
          if (found) {
            sessionStorage.removeItem("target_favorite_company_id");
            selectCompany(found);
            return;
          }
        }
        selectCompany(favoriteCompaniesSearched[0]);
      }
    }
  }, [menu, companies, favoriteCompaniesSearched, selectCompany]);


  const fetchCompaniesData = async () => {
    setCompanies([]);
    setLoading(true); // Set loading to true before fetching
    setOffset(0);
    const appliedFilters = {
      company: companySearch,
      job_titles: jobTitles,
      job_types: selectedJobTypes,
    };
    const resdata = await fetchCompaniesList({
      page: 1,
      limit: companiesPerPage,
      appliedFilters
    });
    if (resdata.companies.length > 0) {
      setCompanies(resdata.companies);
      setOffset(offset + resdata.companies.length);
      setTotalPages(resdata.total_pages || 1); // <-- Set total pages from backend
      setCompaniesTotalCount(resdata.count || resdata.companies.length || 0);
    } else {
      setCompaniesTotalCount(0);
    }
    setLoading(false); // Set loading to false after fetching
  };
  const getCOmpanyContacts = (companyId, offset = 0, clear = true) => {
    if (clear) {
      setCompanyContacts([]);
    }
    setContactsLoadComplete(false);
    setContactsLoading(true);
    axios.post(`${Key.domain_crm}/company/get_Company_Contacts`, {
      company_id: companyId,
      page: offset,
    })
      .then((res) => {
        const contacts = res?.data?.data?.companyContacts || [];
        setCompanyContacts(contacts);
        //setContactDetails(contacts[0]);
        setselectedcontact(contacts[0]?.ID);
      })
      .finally(() => {
        setContactsLoading(false);
        setContactsLoadComplete(true);
      });
  };

  const handleMenuItemClick = (filterType) => {
    setDateFilter(filterType);
    applyDateFilter(filterType);
    handleClose();
    getCompanyJobs(companyId, 0, filterType);
  };

  const handleClick = (event) => {
    setFilter(event.currentTarget);
  };
  const handleClose = () => {
    setFilter(null);
  };


  const getCompanyJobs = (compId, offset, filterType, jobFilterOverrides = {}) => {
    const company_id = compId ? compId : companyDetails?.id;
    if (company_id === undefined || company_id === null || company_id === "") {
      return;
    }

    const joboffsetvalue = offset !== undefined ? offset : joboffsetRef.current;
    const isInitialLoad = parseInt(joboffsetvalue) === 0;
    const titles =
      jobFilterOverrides.job_titles !== undefined
        ? jobFilterOverrides.job_titles
        : jobTitles;
    const types =
      jobFilterOverrides.job_types !== undefined
        ? jobFilterOverrides.job_types
        : selectedJobTypes;

    if (!isInitialLoad && (!jobshasmoreRef.current || jobsFetchInFlightRef.current)) {
      return;
    }

    if (isInitialLoad) {
      joboffsetRef.current = 0;
      setjobshasmore(true);
      jobshasmoreRef.current = true;
    }

    const requestId = ++jobsFetchRequestIdRef.current;
    jobsFetchInFlightRef.current = true;
    setJobsLoading(true);
    // When auto-selecting the first job on initial load, getJobDetail owns this flag —
    // do not clear it in finally or the detail panel flashes "No Job Selected".
    let fetchingJobDetail = false;

    axios
      .post(`${Key.domain_crm}/company/get-jobs-by-company-title`, {
        company_id: company_id,
        page: joboffsetvalue,
        job_titles: titles,
        job_types: types,
      })
      .then((resdata) => {
        if (requestId !== jobsFetchRequestIdRef.current) {
          return;
        }

        const jobs = resdata?.data?.data?.companyJobs || [];
        const jobsMeta = resdata?.data?.data || {};
        const jobsPageLimit =
          jobsMeta.limit || jobsMeta.pageSize || jobsMeta.page_size || 20;
        const effectiveFilter = filterType !== undefined ? filterType : dateFilter;

        // Stop infinite-scroll when this is the last (or short) page so the bottom
        // skeleton does not stick until the user scrolls.
        const hasMoreFromApi =
          jobsMeta.hasMore ??
          jobsMeta.has_more ??
          (jobsMeta.total != null || jobsMeta.count != null
            ? joboffsetvalue + jobs.length <
            (jobsMeta.total ?? jobsMeta.count)
            : undefined);
        const hasMoreJobs =
          jobs.length === 0
            ? false
            : hasMoreFromApi !== undefined
              ? Boolean(hasMoreFromApi)
              : jobs.length >= jobsPageLimit;

        setjobshasmore(hasMoreJobs);
        jobshasmoreRef.current = hasMoreJobs;

        if (jobs.length > 0) {
          const filteredJobs = applyDateFilter(jobs, effectiveFilter);
          const newOffset = joboffsetvalue + jobs.length;
          joboffsetRef.current = newOffset;
          setjoboffset(newOffset);

          if (isInitialLoad) {
            setCompanyJobs(filteredJobs);
            if (filteredJobs.length > 0) {
              // Highlight first job immediately; force detail fetch so stale
              // selectedJobId early-return does not skip after search/reload.
              setselectedJobId(filteredJobs[0].id);
              setJobDetails({});
              fetchingJobDetail = true;
              getJobDetail(filteredJobs[0].id, { force: true });
            } else {
              setselectedJobId("");
              setJobDetails({});
            }
          } else {
            setCompanyJobs((prevData) => {
              const existingIds = new Set(prevData.map((job) => job.id));
              const uniqueJobs = filteredJobs.filter((job) => !existingIds.has(job.id));
              return [...prevData, ...uniqueJobs];
            });
          }
        } else if (isInitialLoad) {
          setCompanyJobs([]);
          setselectedJobId("");
          setJobDetails({});
        }
      })
      .catch((err) => { })
      .finally(() => {
        if (requestId !== jobsFetchRequestIdRef.current) {
          return;
        }
        jobsFetchInFlightRef.current = false;
        setJobsLoading(false);
        if (!fetchingJobDetail) {
          setSelectedJobLoader(false);
        }
        if (isInitialLoad) {
          setJobsLoadComplete(true);
        }
      });
  };

  const loadMoreCompanyJobs = () => {
    if (!jobshasmoreRef.current || jobsFetchInFlightRef.current) {
      return;
    }
    getCompanyJobs();
  };

  const applyDateFilter = (jobs, filterType) => {
    const today = new Date();
    let startdate;

    if (filterType === "today") {
      startdate = moment(today)
        .subtract(24, "h")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
    } else if (filterType === "yesterday") {
      startdate = moment(today)
        .subtract(1, "d")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
    } else if (filterType === "3days") {
      startdate = moment(today)
        .subtract(3, "d")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
    } else if (filterType === "1week") {
      startdate = moment(today)
        .subtract(7, "d")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
    } else if (filterType === "1month") {
      startdate = moment(today)
        .subtract(30, "d")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
    } else if (filterType === "all") {
      startdate = moment("2022-01-01").utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
    } else {
      startdate = null;
    }

    if (startdate) {
      return jobs.filter((job) => new Date(job.created) >= new Date(startdate));
    }
    return jobs;
  };

  const getJobDetail = (jobId, { force = false } = {}) => {
    if (!force && String(selectedJobId) === String(jobId)) return;
    setSelectedJobLoader(true);
    axios
      .post(`${Key.domain_crm}/company/get-job-details`, {
        job_id: jobId,
      })
      .then((resdata) => {
        if (resdata?.data.success === 1) {
          setJobDetailsLoader(false);
          setJobDetails(resdata?.data?.data?.job_detail);
          setselectedJobId(jobId);
          let job_contact_id = resdata?.data?.data?.job_detail?.job_contact_id;
          if (job_contact_id) {
            getContactDetail(resdata?.data?.data?.job_detail?.job_contact_id);
            //setShowContacts(false);
          } else {
            setShowContacts(true);
          }
        } else {
          setJobDetailsLoader(true);
        }
      })
      .finally(() => {
        setSelectedJobLoader(false);
      })
  };

  const getContactDetail = (id) => {
    if (id !== 0) {
      axios
        .post(`${Key.domain_crm}/company/get_contact_detail`, {
          contact_id: id,
        })
        .then((resdata) => {
          if (
            resdata?.data.success === 1 &&
            resdata?.data?.data?.contact_detail
          ) {
            setContactDetails(resdata?.data?.data?.contact_detail);
            setselectedcontact(resdata?.data?.data?.contact_detail?.ID || 0);
          } else {
          }
        });
    }
  };
  const getContactMailData = (contact) => {
    axios
      .post(`${Key.domain_crm}/company/get_contact_mails_data`, {
        contact_id: contact.ID,
        user_id: sessionStorage.getItem("id"),
      })
      .then((resData) => {
        setContactMailData(resData.data.data);
      });
  };
  const sendMailRecruiter = (contact) => {
    setSendMail(!sendMail);
    setShowMailForm(false);
    getContactMailData(contact);
  };

  const handleSendMail = (contact) => {
    if (subject != "" && message != "") {
      try {
        axios
          .post(`${Key.domain_crm}/company/sendMail`, {
            contact_email: contact.EMP_CONTACT_EMAIL,
            subject: subject,
            message: message,
            userId: sessionStorage.getItem("id"),
            contactId: contact.ID,
            activityType: "email",
          })
          .then((resdata) => {
            setShowMailForm(false);
            setSubject("");
            setMessage("");
            setShowContactMail(false);
            getContactMailData(contact);
            if (resdata.data.success == 1) {
            }
          })
          .catch((error) => console.error(error));
      } catch (err) {
        console.error(err);
      }
    } else {
    }
  };
  const getColor = (index) => {
    const colors = ["#FFAB91", "#DCEDC8", "#FFCCBC", "#FFD180", "#FFCC80"];
    return colors[index % colors.length];
  };
  const handleCopy = (email) => {
    navigator.clipboard.writeText(email).then(() => {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000); // Reset color after 2 seconds
    });
  };
  const updateEmailVerifyStatus = (category) => {
    axios
      .post(`${Key.domain_crm}/company/update_contact_verify_status`, {
        contact_id: contactDetails?.ID,
        company_id: contactDetails?.COMPANY_ID,
        phone_verified:
          category === "Phone" ? 1 : contactDetails?.phone_verified,
        email_verified:
          category === "Email" ? 1 : contactDetails?.email_verified,
        contact_email: contactDetails?.EMP_CONTACT_EMAIL,
        contact_name: contactDetails?.EMP_CONTACT_NAME,
        contact_phone: contactDetails?.EMP_CONTACT_PHONE,
      })
      .then((response) => {
        if (response.data.data.affectedRows > 0) {
          let contactsoffset = 0;
          // Reset ref to allow refresh
          contactsLoadedRef.current = false;
          getCOmpanyContacts(contactDetails?.COMPANY_ID, contactsoffset);
        } else {
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSearchContacts = (searchText, results) => {
    if (searchText.length === 0) {
      // Search is cleared — show full list again
      getCOmpanyContacts(companyId, 0, false);
    } else {
      setCompanyContacts(results); // Filtered results
    }
    setSearchInputValue(searchText);
  };


  const updateJobContact = (contact) => {
    axios
      .post(`${Key.domain_crm}/company/update_job_contact`, {
        contact_id: contact?.ID,
        job_id: jobDetails?.id,
      })
      .then((response) => {
        if (response.data.data.affectedRows > 0) {
        } else {
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleEditContact = () => {
    setShowEditContact(true);
  };
  const handleEditContactClose = (value) => {
    setShowContacts(true);
    setShowEditContact(value);
  };
  const handleAddContactPopupClose = (value) => {
    setShowAddContactPopup(value);
  };

  const addToFavorites = (companyId) => {
    // Store the company so Favourites tab can auto-select it when switching
    sessionStorage.setItem("target_favorite_company_id", String(companyId));
    fetch(`${Key.domain}/common/addToFav`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        favourite: 1,
        user_id: user?.id,
        companyId: companyId,
      }),
    }).then((response) => {
      response.json().then((resdata) => {
        setFavOffset(0);
        // Refresh fav list immediately so it's ready when the user switches tabs
        getFavCompanies(undefined, 1, rowsPerPage);
      });
    });
  };

  const getFavCompanies = async (favid, page = favPage, limit = rowsPerPage, search) => {
    try {
      const response = await fetch(`${Key.domain}/common/getFavouriteCompanies`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: user?.id,
          favid: favid ? favid : 0,
          page: page, // Page number for server-side pagination
          limit: limit, // Limit for server-side pagination
          search: search
        }),
      });
      //console.log('Favourites API response:', response);
      const resdata = await response.json();
      //console.log('Favourites API data:', resdata.data.count);
      if (resdata.data.count === 0) {
        setselectedJobId(null);
        setSelectedCompanyId(null);
        setFavTotalCount(0);
      } else {
        setFavTotalCount(resdata.data.count || 0);
      }
      setFavoriteCompanies(Array.isArray(resdata.data?.data) ? resdata.data.data : []);
      setFavoriteCompaniesSearched(Array.isArray(resdata.data?.data) ? resdata.data.data : []);
      setTotalFavPages(resdata.data?.lastPage || 1);
      const favList = Array.isArray(resdata.data?.data) ? resdata.data.data : [];
      if (menu === "Favourites" && favList.length > 0) {
        autoSelectedFor.current = "Favourites";
        const targetId = sessionStorage.getItem("target_favorite_company_id");
        if (targetId) {
          const found = favList.find((c) => String(c.id) === String(targetId));
          if (found) {
            sessionStorage.removeItem("target_favorite_company_id");
            selectCompany(found, { forceRefresh: true });
            return;
          }
        }
        selectCompany(favList[0], { forceRefresh: true });
      }
    } catch (err) {
      console.error('Favourites API error:', err);
      setFavoriteCompanies([]);
      setFavoriteCompaniesSearched([]);
      setTotalFavPages(1);
      setFavTotalCount(0);
    }
  };
  const hideContactsFun = (value) => {
    setHideContacts(value);
  };

  const removeFromFavorites = (companyId) => {
    fetch(`${Key.domain}/common/removeFavourites`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        companyId: companyId,
        uid: user?.id,
      }),
    }).then((response) => {
      response.json().then((resdata) => {
        setFavOffset(0);
        autoSelectedFor.current = null;
        getFavCompanies();
      });
    });
  };

  useEffect(() => {
    if (menu === "Favourites") {
      getFavCompanies(undefined, favPage, rowsPerPage, searchValue);
    }
  }, [favPage, menu, rowsPerPage]);


  // Fetch companies when page / filters change (server-side pagination)
  useEffect(() => {
    let isMounted = true;

    if (menu !== "Companies") return undefined;

    if (skipNextCompaniesPageFetchRef.current) {
      skipNextCompaniesPageFetchRef.current = false;
      return undefined;
    }

    const fetchData = async () => {
      const fetchId = ++companiesPageFetchIdRef.current;
      setLoading(true);
      const appliedFilters = {
        company: companySearch,
        job_titles: jobTitles,
        job_types: selectedJobTypes,
      };
      try {
        const resdata = await fetchCompaniesList({
          page: page,
          limit: companiesPerPage,
          appliedFilters,
        });
        if (!isMounted || fetchId !== companiesPageFetchIdRef.current) return;

        setCompanies(resdata.companies);
        setTotalPages(resdata.total_pages || 1);
        setCompaniesTotalCount(resdata.count || resdata.companies.length || 0);
        setLoading(false);

        // Select only after the new page payload is present (avoids flash of previous page's company)
        if (resdata.companies?.length > 0) {
          autoSelectedFor.current = "Companies";
          selectCompany(resdata.companies[0], { forceRefresh: true });
        } else {
          setSelectedCompanyId(null);
          setselectedJobId("");
          setCompanyJobs([]);
          setJobsLoading(false);
          setJobsLoadComplete(true);
          setSelectedJobLoader(false);
          setContactsLoading(false);
          setContactsLoadComplete(true);
        }
      } catch (error) {
        if (isMounted && fetchId === companiesPageFetchIdRef.current) {
          setLoading(false);
        }
        console.error("Failed to fetch companies", error);
      }
    };

    // Debounce only free-text search; page / page-size changes should be immediate
    if (searchValue) {
      const handler = setTimeout(fetchData, 750);
      return () => {
        isMounted = false;
        clearTimeout(handler);
      };
    }

    fetchData();
    return () => {
      isMounted = false;
    };
  }, [page, menu, searchValue, companiesPerPage]);

  const handleApplyFilters = async () => {
    beginFilterTransition();
    setFilterDialogOpen(false);

    const fetchId = ++companiesPageFetchIdRef.current;

    try {
      const appliedFilters = {
        company: companySearch,
        job_titles: jobTitles,
        job_types: selectedJobTypes,
      };

      const resdata = await fetchCompaniesList({
        page: 1,
        limit: companiesPerPage,
        appliedFilters,
      });

      if (fetchId !== companiesPageFetchIdRef.current) return;

      const hasFilters = Boolean(
        (companySearch && companySearch.trim() !== "") ||
        (jobTitles && jobTitles.length > 0) ||
        (selectedJobTypes && selectedJobTypes.length > 0)
      );
      setAppliedFilters(hasFilters);

      // Avoid a second companies fetch from the page effect when we already have results
      skipNextCompaniesPageFetchRef.current = true;
      setPage(1);

      if (resdata?.companies?.length > 0) {
        setCompanies(resdata.companies);
        autoSelectedFor.current = "Companies";
        selectCompany(resdata.companies[0], {
          forceRefresh: true,
          jobFilterOverrides: {
            job_titles: jobTitles,
            job_types: selectedJobTypes,
          },
        });
        setOffset(resdata.companies.length);
        setTotalPages(resdata.total_pages || 1);
        setCompaniesTotalCount(resdata.count || resdata.companies.length || 0);
      } else {
        setCompanies([]);
        setTotalPages(1);
        setCompaniesTotalCount(0);
        setSelectedCompanyId(null);
        setselectedJobId("");
        setCompanyJobs([]);
        setJobsLoading(false);
        setJobsLoadComplete(true);
        setSelectedJobLoader(false);
        setContactsLoading(false);
        setContactsLoadComplete(true);
        resetToScrollStart();
      }
    } catch (error) {
      console.error("Error applying filters:", error);
      setCompanies([]);
      setJobsLoading(false);
      setJobsLoadComplete(true);
      setSelectedJobLoader(false);
      setContactsLoading(false);
      setContactsLoadComplete(true);
    } finally {
      if (fetchId === companiesPageFetchIdRef.current) {
        setLoading(false);
      }
    }
  };

  const handleClearAllFilters = async () => {
    beginFilterTransition();
    setCompanySearch("");
    setJobTitles([]);
    setSelectedJobTypes([]);
    setFilterDialogOpen(false);
    setAppliedFilters(false);

    const fetchId = ++companiesPageFetchIdRef.current;

    try {
      const resdata = await fetchCompaniesList({
        page: 1,
        limit: companiesPerPage,
      });

      if (fetchId !== companiesPageFetchIdRef.current) return;

      skipNextCompaniesPageFetchRef.current = true;
      setPage(1);

      if (resdata?.companies?.length > 0) {
        setCompanies(resdata.companies);
        autoSelectedFor.current = "Companies";
        selectCompany(resdata.companies[0], {
          forceRefresh: true,
          // State clears above are async — force jobs to use empty filters now
          jobFilterOverrides: { job_titles: [], job_types: [] },
        });
        setOffset(resdata.companies.length);
        setTotalPages(resdata.total_pages || 1);
        setCompaniesTotalCount(resdata.count || resdata.companies.length || 0);
      } else {
        setCompanies([]);
        setTotalPages(1);
        setCompaniesTotalCount(0);
        setSelectedCompanyId(null);
        setselectedJobId("");
        setCompanyJobs([]);
        setJobsLoading(false);
        setJobsLoadComplete(true);
        setSelectedJobLoader(false);
        setContactsLoading(false);
        setContactsLoadComplete(true);
        resetToScrollStart();
      }
    } catch (error) {
      console.error("Error clearing filters:", error);
      setJobsLoading(false);
      setJobsLoadComplete(true);
      setSelectedJobLoader(false);
      setContactsLoading(false);
      setContactsLoadComplete(true);
    } finally {
      if (fetchId === companiesPageFetchIdRef.current) {
        setLoading(false);
      }
    }
  };


  // JOB-TYPES
  const jobTypes = [
    { id: 1, label: "Full-Time" },
    { id: 2, label: "Part-Time" },
    { id: 3, label: "Internship" },
    { id: 4, label: "W2 - Permanent" },
    { id: 5, label: "W2 - Contract" },
    { id: 6, label: "1099-Contract" },
    { id: 7, label: "Contract to Hire" },
    { id: 8, label: "Need H1B" },
    { id: 9, label: "Hourly Employee" },
    { id: 10, label: "Contract Based" },
    { id: 11, label: "Contract - Corp-to-Corp" },
    { id: 13, label: "Contract - Independent" },
    { id: 14, label: "Contract to Hire - Corp-to-Corp" },
    { id: 15, label: "Contract to Hire - W2" },
    { id: 16, label: "Contract to Hire - Independent" },
  ];

  // Open dialog when filter icon is clicked
  const handleFilterClick = () => {
    setFilterDialogOpen(true);
  };

  const TRUTHY_CONTACT_VALUES = [1, '1', true]

  const recruiterData = jobDetails?.contactInfo ? jobDetails?.contactInfo : companyContacts?.[0];
  const isRecruiterFromJobDetails = Boolean(jobDetails?.contactInfo);
  const recruiterSectionTitle = isRecruiterFromJobDetails ? "Recruiter Details" : "Meet Hiring Team";

  const panelPaperStyles = {
    borderRadius: "8px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  };

  const listPaginationFooterSx = {
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    p: 1,
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    bgcolor: "#fff",
  };

  const panelChildWrapSx = {
    flex: 1,
    minHeight: 0,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  };

  return (
    <>
      <Box
        sx={{
          height: "calc(100vh - 66px)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          //pt: 0.25,
          ml: { xs: -1, md: -2 },
          mr: { xs: -0.5, md: -1 },
          width: { xs: "calc(100% + 12px)", md: "calc(100% + 24px)" },
          boxSizing: "border-box",
        }}
      >
        {searchType === "contact" ? (
          <Contacts />
        ) : (
          <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>
            <Grid container spacing={0.5} sx={{ flex: 1, minHeight: 0, m: 0, width: "100%", "& > .MuiGrid-item": { minHeight: 0 } }}>
              <Grid item xs={isMobile || isTablet ? 12 : 2.4} sx={{ height: "100%", minHeight: 0 }}>
                <Paper elevation={2} sx={panelPaperStyles}>
                  <Toolbar
                    sx={{
                      pl: { sm: 2 },
                      pr: { xs: 1, sm: 1 },
                      minHeight: "42px !important",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      {showSearchInput ? (
                        <>
                          <InputBase
                            placeholder="Search..."
                            value={searchValue}
                            onChange={handleSearchInputChange}
                          />
                          <div onClick={() => closeSearchCompanies()}>
                            <RxCross2
                              style={{
                                fontSize: "medium",
                                color: "rgb(0 0 0 / 70%)",
                                marginLeft: "8px",
                                marginTop: "10px",
                              }}
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <Button
                            variant="text"
                            sx={{
                              textTransform: "capitalize",
                              color: menu === "Companies" ? "#406882" : "black",
                              borderRadius: "0px",
                              padding: "6px 12px",
                              borderBottom:
                                menu === "Companies"
                                  ? " 3px solid #406882"
                                  : "3px solid transparent",
                            }}
                            onClick={() => {
                              handleMenuChange("Companies");
                              // Do NOT call fetchCompaniesData() here or in any other handler
                            }}
                          >
                            Companies
                          </Button>
                          <Button
                            variant="text"
                            sx={{
                              textTransform: "capitalize",
                              color: menu === "Favourites" ? "#406882" : "black",
                              borderRadius: "0px",
                              padding: "6px 12px",
                              borderBottom:
                                menu === "Favourites"
                                  ? "3px solid #406882"
                                  : "3px solid transparent",
                            }}
                            onClick={() => {
                              handleMenuChange("Favourites");
                            }}
                          >
                            Favourites
                          </Button>
                          {
                            menu === "Companies" ? (<Tooltip title="Filter">
                              <IconButton onClick={handleFilterClick}>
                                <FilterListIcon
                                  sx={{
                                    color: "#696969",
                                    cursor: "pointer",
                                    "&:hover": {
                                      color: "#406882",
                                    },
                                    fontSize: "22px",
                                  }}
                                />
                                {/* Blue dot indicator if filter is applied */}
                                {isFilterApplied && (
                                  <Box
                                    sx={{
                                      position: "absolute",
                                      top: 6,
                                      right: 6,
                                      width: 8,
                                      height: 8,
                                      bgcolor: "#1976d2",
                                      borderRadius: "50%",
                                      boxShadow: "0 0 2px #1976d2",
                                      zIndex: 1,
                                    }}
                                  />
                                )}
                              </IconButton>
                            </Tooltip>) :
                              <Tooltip title="Search">
                                <IconButton onClick={handleSearchClick}>
                                  <SearchIcon sx={{
                                    color: "#696969",
                                    cursor: "pointer",
                                    "&:hover": {
                                      color: "#406882",
                                    },
                                    fontSize: "22px",
                                  }} />
                                </IconButton>
                              </Tooltip>
                          }
                        </>
                      )}
                    </Box>
                  </Toolbar>
                  <Divider sx={{ margin: 0 }} />
                  {menu === "Companies" ? (
                    <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>
                      <List
                        sx={{
                          width: "100%",
                          bgcolor: "background.paper",
                          padding: 0,
                          m: 0,
                          flex: 1,
                          minHeight: 0,
                          overflowY: "auto",
                        }}
                      >
                        <div ref={scrollRef}>
                          {loading ? (
                            <LoadingSkeleton />
                          ) : (
                            companies &&
                            companies.map((value, index) => (
                              <Typography
                                key={index}
                                onClick={() => selectCompany(value)}
                                onMouseEnter={() => {
                                  setIsHovered(true);
                                }}
                                onMouseLeave={() => {
                                  setIsHovered(false);
                                }}
                                sx={{
                                  cursor: "pointer",
                                  backgroundColor:
                                    selectedCompanyId === value.id ? "rgba(25, 118, 210, 0.08)" : "white",
                                }}
                              >
                                <div
                                  className="p-2"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      flex: "0 0 auto",
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "50%",
                                      backgroundColor: getColor(index),
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginRight: "10px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        color: "#000",
                                      }}
                                    >
                                      {`${value.name.charAt(0)}${value.name.charAt(value.name.length - 1)}`}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      flex: "1 1 auto",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    <span
                                      title={value.name}
                                      style={{
                                        color: "rgb(33 37 41 / 80%)",
                                        fontSize: "12px",
                                        fontWeight: 700,
                                        cursor: "pointer",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {value.name.length > 25
                                        ? `${value.name.slice(0, 25)}...`
                                        : value.name}
                                    </span>
                                  </div>
                                  {isHovered && selectedCompanyId === value.id && (
                                    <div
                                      style={{
                                        flex: "0 0 auto",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      <Tooltip
                                        title={value?.isFavorite ? "Remove from favorites" : "Add to favorites"}
                                      >
                                        <IconButton
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            if (value?.isFavorite) {
                                              removeFromFavorites(value?.id);
                                              setCompanies((prev) =>
                                                prev.map((c) =>
                                                  c.id === value?.id ? { ...c, isFavorite: false } : c
                                                )
                                              );
                                              toast.success("Removed from favorites");
                                            } else {
                                              addToFavorites(value?.id);
                                              setCompanies((prev) =>
                                                prev.map((c) =>
                                                  c.id === value?.id ? { ...c, isFavorite: true } : c
                                                )
                                              );
                                              toast.success("Added to favorites");
                                            }
                                          }}
                                        >
                                          {value?.isFavorite ? (
                                            <Star sx={{ color: "gold", fontSize: 20 }} />
                                          ) : (
                                            <StarBorder sx={{ color: "gold", fontSize: 20 }} />
                                          )}
                                        </IconButton>
                                      </Tooltip>
                                    </div>
                                  )}
                                </div>
                              </Typography>
                            ))
                          )}
                        </div>
                      </List>
                      <Box sx={listPaginationFooterSx}>
                        <Pagination
                          color="primary"
                          count={totalPages}
                          page={page}
                          onChange={(e, value) => {
                            if (value === page) return;
                            beginCompaniesPageTransition();
                            setPage(value);
                          }}
                          size="small"
                          sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}
                          siblingCount={0}
                          boundaryCount={1}
                        />
                        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 1, px: 1 }}>
                          {companiesTotalCount >= 10 && (
                            <>
                              <Typography variant="body2">Rows per page:</Typography>
                              <Select
                                size="small"
                                variant="standard"
                                value={companiesPerPage}
                                onChange={(e) => {
                                  beginCompaniesPageTransition();
                                  setCompaniesPerPage(e.target.value)
                                  setPage(1)
                                }}
                                sx={{ minWidth: 60 }}
                              >
                                {[10, 20, 50, 100].map(n => (
                                  <MenuItem key={n} value={n}>{n}</MenuItem>
                                ))}
                              </Select>
                            </>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  ) : menu === "Favourites" ? (
                    <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>
                      <List
                        sx={{
                          width: "100%",
                          bgcolor: "background.paper",
                          padding: 0,
                          m: 0,
                          flex: 1,
                          minHeight: 0,
                          overflowY: "auto",
                        }}
                      >
                        <div ref={scrollRef}>
                          {favoriteCompaniesSearched && favoriteCompaniesSearched.length > 0 ? (
                            favoriteCompaniesSearched.map((company, index) => (
                              <Typography
                                onMouseEnter={() => {
                                  setIsHovered(true);
                                }}
                                onMouseLeave={() => {
                                  setIsHovered(false);
                                }}
                                key={index}
                                style={{
                                  backgroundColor:
                                    selectedCompanyId === company.id
                                      ? "rgba(25, 118, 210, 0.08)"
                                      : "white",
                                  padding: "0px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div
                                  className="p-2"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      flex: "0 0 auto",
                                      width: "40px",
                                      height: "40px",
                                      borderRadius: "50%",
                                      backgroundColor: getColor(index),
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      marginRight: "10px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        color: "#000",
                                      }}
                                    >
                                      {`${company.name.charAt(0)}${company.name.charAt(company.name.length - 1)}`}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      flex: "1 1 auto",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      title={company.name}
                                      style={{
                                        color: "rgb(33 37 41 / 80%)",
                                        fontSize: "12px",
                                        fontWeight: 700,
                                        cursor: "pointer",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        flexGrow: 1,
                                      }}
                                      onClick={() => selectCompany(company)}
                                    >
                                      {company.name.length > 25
                                        ? `${company.name.slice(0, 25)}...`
                                        : company.name}
                                    </span>

                                    {isHovered &&
                                      selectedCompanyId === company.id && (
                                        <Tooltip title="Remove from favorites">
                                          <IconButton
                                            onClick={() => removeFromFavorites(company.id)}
                                            sx={{ cursor: "pointer" }}
                                          >
                                            <Star
                                              sx={{
                                                color: "gold",
                                                fontSize: 20,
                                              }}
                                            />
                                          </IconButton>
                                        </Tooltip>

                                      )}
                                  </div>
                                </div>
                              </Typography>
                            ))
                          ) : (
                            <div
                              style={{
                                height: "100%", // match your panel height
                                minHeight: "200px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <h6 style={{ marginTop: "20px", color: "#696969" }}>Data not found</h6>
                            </div>
                          )}

                        </div>
                      </List>
                      <Box sx={listPaginationFooterSx}>
                        <Pagination
                          color="primary"
                          count={totalFavPages || 1}
                          page={favPage}
                          onChange={(e, value) => {
                            if (value === favPage) return;
                            beginCompaniesPageTransition();
                            setFavPage(value);
                          }}
                          size="small"
                          sx={{ display: "flex", justifyContent: "center", mb: 1 }}
                          siblingCount={0}
                          boundaryCount={1}
                        />
                        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 1, px: 1 }}>
                          {favTotalCount >= 10 && (
                            <>
                              <Typography variant="body2">Rows per page:</Typography>
                              <Select
                                size="small"
                                variant="standard"
                                value={rowsPerPage}
                                onChange={(e) => {
                                  beginCompaniesPageTransition();
                                  setRowsPerPage(e.target.value);
                                  setFavPage(1);
                                }}
                                sx={{ minWidth: 60 }}
                              >
                                {[10, 20, 50, 100].map((n) => (
                                  <MenuItem key={n} value={n}>
                                    {n}
                                  </MenuItem>
                                ))}
                              </Select>
                            </>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  ) : null}

                </Paper>

              </Grid>
              <Grid
                item
                xs={isMobile || isTablet ? 12 : 9.6}
                sx={{ height: "100%", minHeight: 0, display: "flex", flexDirection: "column" }}
              >
                <Grid
                  container
                  spacing={0.5}
                  sx={{
                    flex: 1,
                    minHeight: 0,
                    height: "100%",
                    width: "100%",
                    alignItems: "stretch",
                    "& > .MuiGrid-item": {
                      display: "flex",
                      minHeight: 0,
                      overflow: "hidden",
                    },
                  }}
                >
                  <Grid item xs={12} md={3} sx={{ height: "100%", minHeight: 0, display: "flex" }}>
                    <CompanyJobs
                      companyJobs={companyJobs}
                      getCOmpanyJobs={loadMoreCompanyJobs}
                      jobshasmore={jobshasmore}
                      selectedJobId={selectedJobId}
                      getJobDetail={getJobDetail}
                      handleClick={handleClick}
                      jobsLoading={jobsLoading}
                      jobsLoadComplete={jobsLoadComplete}
                      hasJobs={companyJobs?.length > 0}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} sx={{ height: "100%", minHeight: 0, display: "flex" }}>
                    <CompanyJobDetail
                      jobDetails={jobDetails}
                      selectedJobId={selectedJobId}
                      jobsLoading={jobsLoading}
                      jobsLoadComplete={jobsLoadComplete}
                      selectedJobLoader={selectedJobLoader}
                      showContact={() => setShowContacts(!showContacts)}
                      hasJobs={companyJobs?.length > 0}
                    />
                  </Grid>
                  {companyJobs?.length > 0 && selectedJobId ? (
                    <>
                      {showContacts ? (
                        <Grid item xs={12} md={3} sx={{ height: "100%", minHeight: 0, display: "flex" }}>
                          <Paper elevation={2} sx={{ ...panelPaperStyles, flex: 1, minHeight: 0 }}>
                            <Toolbar
                              sx={{
                                flexShrink: 0,
                                pl: { sm: 2 },
                                pr: { xs: 1, sm: 1 },
                                minHeight: "42px !important",
                                bgcolor: "#fff",
                                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                              }}
                            >
                              <Typography sx={{ fontWeight: 500, margin: 0 }} paragraph id="tableTitle" component="div">
                                {recruiterSectionTitle}
                              </Typography>
                            </Toolbar>

                            <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                              <Box sx={{ flexShrink: 0 }}>
                                {(jobsLoading || selectedJobLoader || contactsLoading || !jobsLoadComplete) ? (
                                  // Skeleton while recruiter data is loading
                                  <Box sx={{ p: 1.5, height: "100px" }}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                      <Skeleton variant="circular" width={60} height={60} />
                                      <Box sx={{ flex: 1 }}>
                                        <Skeleton variant="text" width="70%" height={18} />
                                        <Skeleton variant="text" width="45%" height={14} />
                                      </Box>
                                    </Box>
                                    <Skeleton variant="text" width="85%" height={14} sx={{ mt: 1 }} />
                                  </Box>
                                ) :
                                  recruiterData ? (
                                    <Box sx={{ position: "relative", padding: "4px", width: "100%", height: "100px" }}>
                                      {/* Avatar */}
                                      <Box sx={{ display: "flex" }}>
                                        <Box
                                          sx={{
                                            borderLeft: "6px solid rgba(64, 104, 130, 0.8)",
                                            borderTop: "2px solid rgba(64, 104, 130, 0.8)",
                                            borderBottom: "2px solid rgba(64, 104, 130, 0.8)",
                                            borderRadius: "50%",
                                            position: "absolute",
                                            top: "10px",
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              borderLeft: "4px solid #fff",
                                              borderTop: "1px solid #fff",
                                              borderBottom: "1px solid #fff",
                                              borderRadius: "50%",
                                            }}
                                          >
                                            <Avatar
                                              src={recruiterData?.recruiter_profile_photo || recruiterData?.EMP_PHOTO_URL || ""}
                                              sx={{ height: 60, width: 60 }}
                                            >
                                              {(recruiterData?.recruiterName?.[0] || recruiterData?.EMP_CONTACT_NAME?.[0] || "").toUpperCase()}
                                            </Avatar>
                                          </Box>
                                        </Box>
                                      </Box>

                                      {/* Phone */}
                                      {(recruiterData?.recruiterContactPhone || recruiterData?.EMP_CONTACT_PHONE) && (
                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                          <Typography
                                            variant="body2"
                                            sx={{
                                              display: 'inline-flex',
                                              alignItems: 'center',
                                              fontSize: 12,
                                              color: 'rgba(0,0,0,0.7)',
                                              '&:hover': { color: '#406882', textDecoration: 'underline' },
                                            }}
                                          >
                                            <PhoneRounded sx={{ fontSize: 14, mr: 0.5 }} />
                                            {recruiterData.recruiterContactPhone || recruiterData.EMP_CONTACT_PHONE}
                                          </Typography>
                                        </Box>
                                      )}

                                      {/* Email */}
                                      {(recruiterData?.recruiterEmail || recruiterData.EMP_CONTACT_EMAIL) && (
                                        <Box
                                          sx={{
                                            position: "absolute",
                                            left: "115px",
                                            right: "8px",
                                            top: "66px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 0.5,
                                            ".email-text": {
                                              margin: 0,
                                              fontSize: "10px",
                                              color: copied ? "#406882" : "rgba(0,0,0,0.7)",
                                              fontWeight: 600,
                                              cursor: "pointer",
                                              textTransform: "lowercase",
                                              maxWidth: "100%",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            },
                                            "&:hover .email-text": {
                                              color: "#406882",
                                              textDecoration: "underline",
                                            },
                                          }}
                                        >
                                          <Tooltip title={copied ? "Copied!" : "Copy"}>
                                            <ContentCopyOutlined
                                              style={{
                                                fontSize: "12px",
                                                cursor: "pointer",
                                                color: "#406882",
                                              }}
                                              onClick={() => handleCopy(recruiterData.recruiterEmail || recruiterData.EMP_CONTACT_EMAIL)}
                                            />
                                          </Tooltip>
                                          <EmailRounded sx={{ height: "10px", width: "10px" }} />
                                          <Typography variant="button" paragraph className="email-text">
                                            {recruiterData.recruiterEmail || recruiterData.EMP_CONTACT_EMAIL}
                                          </Typography>
                                        </Box>
                                      )}

                                      {/* Name + LinkedIn */}
                                      <Paper
                                        elevation={1}
                                        sx={{
                                          position: "absolute",
                                          left: "65px",
                                          right: 0,
                                          top: "28px",
                                          padding: "3px",
                                          borderRadius: "6px",
                                          width: "auto",
                                        }}
                                      >
                                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                          <Stack
                                            direction="row"
                                            alignItems="center"
                                            spacing={0.5} // space between name and icon
                                            sx={{ maxWidth: "170px" }}
                                          ><Tooltip title={recruiterData.recruiterName || recruiterData.EMP_CONTACT_NAME} followCursor>
                                              <Typography
                                                title={recruiterData?.recruiterName || recruiterData.EMP_CONTACT_NAME}
                                                paragraph
                                                sx={{
                                                  margin: 0,
                                                  whiteSpace: "nowrap",
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                  fontWeight: 800,
                                                  color: "rgba(0,0,0,0.7)",
                                                  textTransform: "capitalize",
                                                  fontSize: "12px",
                                                  flexShrink: 1, // allow ellipsis to work
                                                }}
                                              >
                                                {recruiterData?.recruiterName || recruiterData.EMP_CONTACT_NAME}
                                              </Typography>
                                            </Tooltip>
                                            {TRUTHY_CONTACT_VALUES.includes(recruiterData?.contact_verified || recruiterData.EMP_CONTACT_NAME) &&
                                              (recruiterData?.recruiterEmail || recruiterData.EMP_CONTACT_NAME) && (
                                                <VerifiedIcon sx={{ color: "#1a8cff", fontSize: 16 }} />
                                              )}
                                          </Stack>
                                          {(recruiterData?.recruiter_linkedin || recruiterData?.EMP_LINKEDIN_URL) && (
                                            <Tooltip title="LinkedIn Profile">
                                              <IconButton
                                                href={recruiterData.recruiter_linkedin || recruiterData?.EMP_LINKEDIN_URL}
                                                target="_blank"
                                                rel="noreferrer"
                                                size="small"
                                                sx={{ color: "#0A66C2" }} // LinkedIn blue
                                              >
                                                <LinkedIn fontSize="small" />
                                              </IconButton>
                                            </Tooltip>
                                          )}
                                        </Box>
                                      </Paper>
                                    </Box>
                                  ) : (
                                    <Card
                                      sx={{
                                        p: 1,
                                        mt: 1,
                                        height: "80px",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Typography sx={{ fontSize: "16px", color: "text.secondary" }}>
                                        Recruiter details not found
                                      </Typography>
                                    </Card>
                                  )}
                              </Box>
                              <Divider sx={{ margin: 0, flexShrink: 0 }} />
                              <Toolbar
                                sx={{
                                  flexShrink: 0,
                                  pl: { sm: 2 },
                                  pr: { xs: 1, sm: 1 },
                                  minHeight: "48px !important",
                                  bgcolor: "#fff",
                                }}
                              >
                                <Box
                                  sx={{
                                    flex: "1 1 100%",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <Stack direction="row" alignItems="center">
                                    {!hideContacts ? (
                                      <>
                                        <Typography
                                          sx={{ fontWeight: 500, margin: 0 }}
                                          paragraph
                                          id="tableTitle"
                                          component="div"
                                        >
                                          Contacts
                                        </Typography>
                                        <Tooltip title="Refresh">
                                          <IconButton>
                                            <HiOutlineRefresh
                                              onClick={() =>
                                                getCOmpanyContacts(
                                                  companyDetails?.id,
                                                  0
                                                )
                                              }
                                              fontSize={"18px"}
                                            />
                                          </IconButton>
                                        </Tooltip>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    <Box sx={{ marginLeft: "auto" }}>
                                      {" "}
                                      <div className="col-2">
                                        {parseInt(
                                          sessionStorage.getItem("usertype"),
                                          10
                                        ) === 8 ? (
                                          <div className=" d-flex align-items-center justify-content-start">
                                            <Tooltip title="Add Contact" arrow>
                                              <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() =>
                                                  setShowAddContactPopup(true)
                                                }
                                              >
                                                <CiSquarePlus
                                                  style={{ fontSize: "25px" }}
                                                />
                                              </Button>
                                            </Tooltip>
                                          </div>
                                        ) : null}
                                      </div>
                                      <div
                                        className="col-2"
                                        style={{
                                          paddingTop: "2px",
                                          paddingLeft: "0px",
                                        }}
                                      >
                                        <Search
                                          companyId={companyId}
                                          handleSearchContacts={
                                            handleSearchContacts
                                          }
                                          hideContacts={hideContactsFun}
                                          searchInputValue={searchInputValue}
                                          jobDetails={jobDetails}
                                        />
                                      </div>
                                    </Box>
                                  </Stack>
                                </Box>
                              </Toolbar>
                              <Divider sx={{ margin: 0 }} />
                              <Box id="contactsScrollableDiv" ref={scrollRef} sx={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
                                <InfiniteScroll
                                  dataLength={companyContacts?.length || 0}
                                  hasMore={contactshasmore}
                                  className="infinityscroll"
                                  style={{ overflow: 'hidden' }}
                                  scrollableTarget="contactsScrollableDiv"
                                  pullDownToRefreshThreshold={50}
                                >
                                  {contactsLoading || !contactsLoadComplete ? (
                                    <LoadingSkeleton />
                                  ) : companyContacts?.length > 0 ? (
                                    companyContacts.map((contact, index) => (
                                      <div style={{ cursor: "pointer" }} key={index}>
                                        <List
                                          className="card1"
                                          sx={{
                                            width: "100%",
                                            bgcolor: "background.paper",
                                          }}
                                          style={{
                                            paddingBottom: "0px",
                                            marginBottom: "-6px",
                                          }}
                                        >
                                          <ListItem
                                            alignItems="flex-start"
                                            style={{
                                              paddingBottom: "5px",
                                              paddingTop: "5px",
                                              backgroundColor:
                                                selectedcontact === contact.ID
                                                  ? "rgba(25, 118, 210, 0.08)"
                                                  : "white",
                                            }}
                                          >
                                            <ListItemAvatar>
                                              <Avatar
                                                src={
                                                  contact.EMP_PHOTO_URL != null
                                                    ? contact.EMP_PHOTO_URL
                                                    : "https://static.licdn.com/aero-v1/sc/h/244xhbkr7g40x6bsu4gi6q4ry"
                                                }
                                              />
                                            </ListItemAvatar>
                                            <ListItemText
                                              onClick={() => {
                                                setContactDetails(contact);
                                                setselectedcontact(contact.ID);
                                                setShowContacts(false);
                                                setSendMail(false);
                                                setContactMailData([]);
                                              }}
                                              primary={
                                                <div>
                                                  <Typography
                                                    variant="body2"
                                                    style={{
                                                      fontSize: "12px",
                                                      fontWeight: "700",
                                                    }}
                                                  >
                                                    {contact.EMP_CONTACT_NAME}
                                                    {((TRUTHY_CONTACT_VALUES.includes(contact?.contact_verified)) && (TRUTHY_CONTACT_VALUES.includes(contact?.email_verified) && contact?.EMP_CONTACT_EMAIL)) ? (
                                                      <VerifiedIcon sx={{ color: "#1a8cff", fontSize: 16, ml: 0.5 }} />
                                                    ) : null}
                                                    {parseInt(sessionStorage.getItem("usertype"), 10) === 8 ? (
                                                      <div>
                                                        <Tooltip title="Edit" arrow placement="top">
                                                          <span
                                                            style={{ float: "right" }}
                                                            onClick={() => handleEditContact()}
                                                          >
                                                            <IoPricetagOutline
                                                              className="edit-icon"
                                                              style={{ fontSize: "15px", color: "rgb(0 0 0 / 60%)" }}
                                                            />
                                                          </span>
                                                        </Tooltip>
                                                      </div>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </Typography>
                                                </div>
                                              }
                                              secondary={
                                                <div>
                                                  <Typography
                                                    sx={{
                                                      display: "inline",
                                                      overflow: "hidden"
                                                    }}
                                                    component="span"
                                                    variant="body2"
                                                    color="text.primary"
                                                    style={{ fontSize: "12px" }}
                                                  >
                                                    {contact.EMP_DECL_TITLE &&
                                                      contact.EMP_DECL_TITLE.slice(0, 50)}
                                                  </Typography>
                                                </div>
                                              }
                                            />
                                          </ListItem>
                                        </List>
                                      </div>
                                    ))
                                  ) : (
                                    <Box
                                      sx={{
                                        height: "100%",
                                        minHeight: 280,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                        width: "100%",
                                      }}
                                    >
                                      <Typography variant="subtitle1" color="text.secondary" sx={{ m: 0 }}>
                                        Data not found
                                      </Typography>
                                    </Box>
                                  )}
                                </InfiniteScroll>
                              </Box>
                            </Box>
                          </Paper>
                        </Grid>
                      ) : (
                        <Grid item xs={12} md={3} sx={{ minHeight: 0, display: "flex" }}>
                          {/* contacts detail view */}

                          <Paper elevation={2} sx={{ ...panelPaperStyles, flex: 1, minHeight: 0 }}>
                            <p
                              style={{ height: "0px" }}
                              onClick={() => {
                                setShowContacts(true);
                              }}
                            >
                              <Tooltip title="Back To Contacts">
                                <IconButton>
                                  <IoIosArrowRoundBack fontSize={"25px"} />
                                </IconButton>
                              </Tooltip>
                            </p>
                            <div className="row">
                              <div style={{ textAlign: "center" }}>
                                <center>
                                  <Avatar
                                    style={{
                                      height: "50px",
                                      width: "50px",
                                      top: "8px",
                                      marginBottom: "14px",
                                    }}
                                    src={
                                      contactDetails &&
                                      contactDetails?.EMP_PHOTO_URL
                                    }
                                  >
                                    <AccountCircleRoundedIcon />
                                  </Avatar>
                                </center>
                                <h3
                                  style={{ marginTop: "5px", fontSize: "15px" }}
                                >
                                  {contactDetails &&
                                    contactDetails?.EMP_CONTACT_NAME}
                                </h3>
                                <p
                                  style={{
                                    fontSize: "12px",
                                    marginBottom: "2px",
                                  }}
                                >
                                  Location&nbsp;:&nbsp;
                                  {contactDetails.EMP_CONTACT_CITY &&
                                    contactDetails.EMP_CONTACT_STATE_PROVINCE
                                    ? `${contactDetails.EMP_CONTACT_CITY}, ${contactDetails.EMP_CONTACT_STATE_PROVINCE}`
                                    : "N/A"}
                                </p>

                                {contactDetails &&
                                  contactDetails?.EMP_LINKEDIN_URL !== "null" &&
                                  contactDetails?.EMP_LINKEDIN_URL && (
                                    <span>
                                      <a
                                        href={contactDetails.EMP_LINKEDIN_URL}
                                        target="_blank"
                                        style={{
                                          textDecoration: "none",
                                          cursor: "pointer",
                                          color: "#000",
                                          fontSize: "12px",
                                        }}
                                      >
                                        <TbBrandLinkedin
                                          color="#212529"
                                          fontSize={"21px"}
                                        />{" "}
                                        Linkedin Profile
                                      </a>
                                    </span>
                                  )}

                                {/* EMAIL */}
                                {contactDetails?.EMP_CONTACT_EMAIL &&
                                  contactDetails?.EMP_CONTACT_EMAIL !== "null" && (
                                    <p style={{ fontSize: "12px", marginBottom: "10px" }}>
                                      {contactDetails.EMP_CONTACT_EMAIL}
                                      {(parseInt(contactDetails.contact_verified) === 1 || contactDetails.contact_verified === true) &&
                                        (parseInt(contactDetails.email_verified) === 1 || contactDetails.email_verified === true) && (
                                          <VerifiedIcon
                                            sx={{ color: "#1a8cff", fontSize: 16, ml: 0.5 }}
                                          />
                                        )}
                                    </p>
                                  )}

                                {/* PHONE */}
                                {contactDetails?.EMP_CONTACT_PHONE &&
                                  contactDetails?.EMP_CONTACT_PHONE !== "null" && (
                                    <p style={{ fontSize: "12px" }}>
                                      {contactDetails.EMP_CONTACT_PHONE}
                                      {/*{(parseInt(contactDetails.contact_verified) === 1 || contactDetails.contact_verified === true) &&
                                      (parseInt(contactDetails.email_verified) === 1 || contactDetails.email_verified === true) && (
                                        <VerifiedIcon
                                          sx={{ color: "#1a8cff", fontSize: 16, ml: 0.5 }}
                                        />
                                      )}*/}
                                    </p>
                                  )}

                                <div
                                  style={{
                                    marginLeft: "12px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      marginRight: "20px",
                                      cursor: "pointer",
                                    }}
                                  // onClick={() => handleclicknotes("email")}
                                  >
                                    {(contactDetails?.EMP_CONTACT_EMAIL &&
                                      contactDetails.EMP_CONTACT_EMAIL !== "None" &&
                                      contactDetails.EMP_CONTACT_EMAIL !== "N/A" &&
                                      contactDetails.EMP_CONTACT_EMAIL !== "email_not_unlocked@domain.com" &&
                                      contactDetails.EMP_CONTACT_EMAIL !== null &&
                                      contactDetails.EMP_CONTACT_EMAIL !== undefined) && (
                                        <>
                                          <a href={`mailto:${contactDetails.EMP_CONTACT_EMAIL}`} style={{ textDecoration: "none" }}>
                                            <img src={Email} width="32px" alt="Email" />
                                          </a>
                                          <p style={{ fontSize: "13px" }}>Email</p>
                                        </>
                                      )}
                                  </div>
                                  {showEditContact ? (
                                    <UpdateCompanyContact
                                      contactDetails={contactDetails}
                                      handleEditContactClose={
                                        handleEditContactClose
                                      }
                                      getCOmpanyContacts={getCOmpanyContacts}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div>
                                {sendMail ? (
                                  !showMailForm ? (
                                    <Container style={{ padding: "0px" }}>
                                      <ul style={{ paddingLeft: "10px" }}>
                                        <Card
                                          style={{
                                            padding: "5px",
                                            height: "150px",
                                            overflow: "auto",
                                          }}
                                        >
                                          <Card.Title
                                            style={{ fontSize: "16px" }}
                                          >
                                            Mails Log
                                          </Card.Title>
                                          {contactMailData.length > 0 ? (
                                            contactMailData.map((item, index) => (
                                              <li
                                                key={index}
                                                style={{
                                                  marginLeft: "4px",
                                                  listStyleType: "none",
                                                }}
                                              >
                                                <Card
                                                  style={{
                                                    padding: "5px",
                                                    marginBottom: "5px",
                                                  }}
                                                >
                                                  <p
                                                    style={{
                                                      fontSize: "12px",
                                                      marginBottom: "4px",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        float: "left",
                                                        fontSize: "12px",
                                                        fontWeight: "600",
                                                        marginRight: "2px",
                                                      }}
                                                    >
                                                      Subject :
                                                    </span>
                                                    {item.subject !== "" &&
                                                      item.subject !== null
                                                      ? `${item.subject[0].toUpperCase() +
                                                      item.subject.slice(
                                                        1,
                                                        20
                                                      )
                                                      }`
                                                      : "N/A"}
                                                    <span
                                                      style={{
                                                        float: "right",
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      {moment(
                                                        item.created
                                                      ).fromNow()}
                                                    </span>
                                                  </p>
                                                  <p
                                                    style={{
                                                      fontSize: "12px",
                                                      marginBottom: "4px",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        float: "left",
                                                        fontSize: "12px",
                                                        fontWeight: "600",
                                                        marginRight: "2px",
                                                      }}
                                                    >
                                                      Message :
                                                    </span>
                                                    <span
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() => {
                                                        setShowContactMessage(
                                                          true
                                                        );
                                                        setContactMailMessage(
                                                          item.message
                                                        );
                                                        setContactMailSubject(
                                                          item.subject
                                                        );
                                                      }}
                                                    >
                                                      {item?.message !== "" &&
                                                        item?.message.length > 0 &&
                                                        item?.message?.length > 20
                                                        ? `${item.message[0].toUpperCase() +
                                                        item.message.slice(
                                                          1,
                                                          20
                                                        )
                                                        }...`
                                                        : item.message[0]?.toUpperCase() +
                                                        item.message.slice(1)}
                                                    </span>
                                                  </p>
                                                </Card>
                                              </li>
                                            ))
                                          ) : (
                                            <p
                                              style={{
                                                fontSize: "12px",
                                                textAlign: "center",
                                                margin: "auto",
                                              }}
                                            >
                                              No Mails Log
                                            </p>
                                          )}
                                        </Card>
                                      </ul>

                                      <Button
                                        style={{
                                          fontSize: "12px",
                                          marginTop: "10px",
                                          marginBottom: "10px",
                                          marginRight: "12px",
                                          backgroundColor: "#fff",
                                          color: "#000",
                                          border: "1px solid gray",
                                          float: "right",
                                        }}
                                        onClick={() => {
                                          setShowMailForm(true);
                                        }}
                                      >
                                        Send Mail
                                      </Button>
                                    </Container>
                                  ) : (
                                    <>
                                      <Container>
                                        <Form>
                                          <Form.Group>
                                            <Form.Label
                                              style={{ fontSize: "12px" }}
                                            >
                                              Subject
                                            </Form.Label>
                                            <Form.Control
                                              type="text"
                                              class="form-control"
                                              placeholder="Enter Subject"
                                              name="subject"
                                              onChange={(e) =>
                                                setSubject(e.target.value)
                                              }
                                              value={subject}
                                            />
                                            <Form.Label
                                              style={{ fontSize: "12px" }}
                                            >
                                              Message
                                            </Form.Label>
                                            <textarea
                                              class="form-control"
                                              placeholder="Enter Message"
                                              id="exampleFormControlTextarea1"
                                              rows="3"
                                              onChange={(e) =>
                                                setMessage(e.target.value)
                                              }
                                              value={message}
                                            ></textarea>
                                          </Form.Group>

                                          <Button
                                            style={{
                                              fontSize: "12px",
                                              float: "right",
                                              marginTop: "10px",
                                              marginBottom: "10px",
                                              marginLeft: "12px",
                                              backgroundColor: "#fff",
                                              color: "#000",
                                              border: "1px solid gray",
                                            }}
                                            onClick={(e) => {
                                              handleSendMail(contactDetails);
                                            }}
                                          >
                                            Send
                                          </Button>
                                        </Form>
                                      </Container>
                                    </>
                                  )
                                ) : (
                                  <ContactActivity
                                    viewComponent={contactActivityView}
                                    contactDetails={contactDetails}
                                  />
                                )}
                              </div>
                            </div>
                          </Paper>
                        </Grid>
                      )}
                    </>
                  ) : !jobsLoadComplete || jobsLoading || selectedJobLoader ? (
                    <Grid item xs={12} md={3} sx={{ height: "100%", minHeight: 0, display: "flex" }}>
                      <Paper elevation={2} sx={{ ...panelPaperStyles, flex: 1, minHeight: 0 }}>
                        <Toolbar
                          sx={{
                            flexShrink: 0,
                            pl: { sm: 2 },
                            pr: { xs: 1, sm: 1 },
                            minHeight: "42px !important",
                            bgcolor: "#fff",
                            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                          }}
                        >
                          <Typography sx={{ fontWeight: 500, margin: 0 }} paragraph id="tableTitle" component="div">
                            {recruiterSectionTitle}
                          </Typography>
                        </Toolbar>
                        <Box sx={{ flex: 1, minHeight: 0, p: 1.5 }}>
                          <LoadingSkeleton />
                        </Box>
                      </Paper>
                    </Grid>
                  ) : (
                    <Grid item xs={12} md={3} sx={{ minHeight: 0, display: "flex" }}>
                      {/* contacts list */}

                      <Paper elevation={2} sx={{ ...panelPaperStyles, flex: 1, minHeight: 0 }}>
                        <Toolbar
                          sx={{
                            flexShrink: 0,
                            pl: { sm: 2 },
                            pr: { xs: 1, sm: 1 },
                            minHeight: "42px !important",
                            bgcolor: "#fff",
                            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
                          }}
                        >
                          <Box
                            sx={{
                              flex: "1 1 100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              sx={{ fontWeight: 500, margin: 0 }}
                              paragraph
                              id="tableTitle"
                              component="div"
                            >
                              {recruiterSectionTitle}
                            </Typography>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                              {companyContacts?.length > 0 && (
                                <Tooltip title="Refresh">
                                  <IconButton
                                    onClick={() =>
                                      getCOmpanyContacts(companyDetails?.id, 0)
                                    }
                                  >
                                    <HiOutlineRefresh fontSize={"18px"} />
                                  </IconButton>
                                </Tooltip>
                              )}
                              {parseInt(sessionStorage.getItem("usertype"), 10) === 8 ? (
                                <Tooltip title="Add Contact" arrow>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => setShowAddContactPopup(true)}
                                    sx={{ minWidth: "auto", p: 0.5 }}
                                  >
                                    <CiSquarePlus style={{ fontSize: "25px" }} />
                                  </Button>
                                </Tooltip>
                              ) : null}
                            </Box>
                          </Box>
                        </Toolbar>
                        <Divider sx={{ margin: 0 }} />
                        <Box
                          sx={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            minHeight: 0,
                            width: "100%",
                          }}
                        >
                          <Typography variant="subtitle1" color="text.secondary" sx={{ m: 0 }}>
                            Data not found
                          </Typography>
                        </Box>
                      </Paper>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Menu anchorEl={filter} open={Boolean(filter)} onClose={handleClose}>
              <MenuItem onClick={() => handleMenuItemClick("all")}>
                <Typography variant="body2">All</Typography>
              </MenuItem>
              <MenuItem onClick={() => handleMenuItemClick("today")}>
                <Typography variant="body2">Today</Typography>
              </MenuItem>

              <MenuItem onClick={() => handleMenuItemClick("1week")}>
                <Typography variant="body2">1 Week Ago</Typography>
              </MenuItem>
              <MenuItem onClick={() => handleMenuItemClick("1month")}>
                <Typography variant="body2">1 Month Ago</Typography>
              </MenuItem>
            </Menu>
            <Modal
              size="md"
              show={showContactMessage}
              onHide={() => setShowContactMessage(false)}
              centered
              style={{ paddingTop: "80px" }}
            >
              <Modal.Header closeButton></Modal.Header>

              <Modal.Body>
                <div>
                  <p style={{ fontSize: "14px" }}>
                    <span style={{ fontWeight: "600", marginRight: "4px" }}>
                      Subject :
                    </span>
                    {contactMailSubject !== "" &&
                      contactMailSubject !== null &&
                      contactMailSubject !== undefined
                      ? contactMailSubject[0].toUpperCase() +
                      contactMailSubject.slice(1)
                      : "N/A"}
                  </p>

                  <p style={{ fontSize: "14px" }}>
                    <span style={{ fontWeight: "600", marginRight: "4px" }}>
                      Message :
                    </span>
                    {contactMailMessage !== "" &&
                      contactMailMessage !== null &&
                      contactMailMessage !== undefined
                      ? contactMailMessage[0].toUpperCase() +
                      contactMailMessage.slice(1)
                      : "N/A"}
                  </p>
                </div>
              </Modal.Body>
            </Modal>
            {showAddContactPopup ? (
              <AddCompanyContact
                showAddContactPopup={showAddContactPopup}
                companyDetails={companyDetails}
                getCOmpanyContacts={getCOmpanyContacts}
                handleAddContactPopupClose={handleAddContactPopupClose}
              />
            ) : (
              ""
            )}
          </Box>
        )}
      </Box>
      {/* Dialog for filter/search */}
      <Dialog
        open={filterDialogOpen}
        onClose={() => setFilterDialogOpen(false)}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          style: {
            background: "rgba(0,0,0,0.2)",
            boxShadow: "none",
            backdropFilter: "blur(2px)",
          },
        }}
      >

        <DialogContent
          style={{
            background: "rgba(255,255,255,0.97)",
            boxShadow: "0 2px 16px rgba(0,0,0,0.12)",
            padding: 0,
            borderRadius: 8,
            display: "flex",
            flexDirection: "column",
            maxHeight: "85vh",
          }}
        >
          <Box sx={{ flex: 1, overflowY: "auto", p: 3 }}>
            <Stack direction={'row'} justifyContent="space-between" alignItems="center">
              <Typography variant="subtitle1" sx={{ mb: 1, mt: 2 }}>
                Company
              </Typography>
              <Button variant="outlined" onClick={handleClearAllFilters}>
                Clear Filters
              </Button>
            </Stack>
            {/* Company Search */}
            <TextField
              type="text"
              fullWidth
              variant="outlined"
              label="Search For Companies"
              value={companySearch ?? ""}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setCompanySearch(e.target.value ?? "");
                  setFilterDialogOpen(false);
                }
              }}
              onChange={(e) => setCompanySearch(e.target.value ?? "")}
              sx={{ mb: 2 }}
            />

            {/* Job Titles */}
            <Typography variant="subtitle1" sx={{ mb: 1, mt: 2 }}>
              Job Titles
            </Typography>
            <Box sx={{ display: "flex", alignItems: 'center', gap: 1, mb: 2 }}>
              <TextField
                type="text"
                variant="outlined"
                label="Job Title"
                value={jobTitleInput ?? ""}
                onChange={(e) => {
                  setJobTitleInput(e.target.value ?? "");
                  setJobTitleError(""); // clear error while typing
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    const trimmed = jobTitleInput?.trim();
                    if (trimmed === "") return;

                    if (jobTitles?.includes(trimmed)) {
                      setJobTitleError("This job title is already added.");
                    } else {
                      setJobTitles([...(jobTitles ?? []), trimmed]);
                      setJobTitleInput("");
                      setJobTitleError("");
                    }
                  }
                }}
                error={Boolean(jobTitleError)}
                helperText={jobTitleError}
                sx={{ flex: 1 }}
              />
              <IconButton
                color="primary"
                disabled={jobTitleInput?.trim() === ""}
                onClick={() => {
                  const trimmed = jobTitleInput?.trim();
                  if (trimmed === "") return;

                  if (jobTitles?.includes(trimmed)) {
                    setJobTitleError("This job title is already added.");
                  } else {
                    setJobTitles([...(jobTitles ?? []), trimmed]);
                    setJobTitleInput("");
                    setJobTitleError("");
                  }
                }}
                sx={{
                  ml: 1,
                  bgcolor: jobTitleInput?.trim() === "" ? "#e0e0e0" : "#1976d2",
                  color: jobTitleInput?.trim() === "" ? "#9e9e9e" : "#fff",
                  "&:hover": {
                    bgcolor: jobTitleInput?.trim() === "" ? "#e0e0e0" : "#1565c0",
                  },
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                }}
              >
                <TrendingFlatIcon fontSize="small" />
              </IconButton>
            </Box>

            {/* Job Titles Chips */}
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 3 }}>
              {jobTitles?.map((jt, idx) => (
                <Chip
                  key={idx}
                  label={jt}
                  onDelete={() =>
                    setJobTitles((prev) => prev?.filter((t) => t !== jt))
                  }
                  sx={{
                    backgroundColor: "#e0e0e0",
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#d5d5d5" },
                  }}
                />
              ))}
            </Box>

            {/* Job Type Dropdown */}
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              Job Type
            </Typography>
            <Grid container spacing={1} sx={{ mb: 3 }}>
              {jobTypes.map((jt) => (
                <Grid item xs={6} key={jt.id}> {/* 6 = half width (2 columns) */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedJobTypes.includes(jt.id)}
                        onChange={() => {
                          setSelectedJobTypes((prev) =>
                            prev.includes(jt.id)
                              ? prev.filter((id) => id !== jt.id) // remove
                              : [...prev, jt.id] // add
                          );
                        }}
                        color="primary"
                        size="small"
                      />
                    }
                    label={jt.label}
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: 14,
                        marginLeft: "4px",
                      },
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions
          style={{
            background: "rgba(255,255,255,0.97)",
            padding: "16px 24px",
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
            boxShadow: "0 -2px 10px rgba(0,0,0,0.05)"
          }}
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setFilterDialogOpen(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setFilterDialogOpen(false);
              handleApplyFilters();
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Companyinfo;